import styled, { keyframes } from 'styled-components';
const loader = keyframes `
  0% { transform: translate(0px,-50%) scale(0); }
  25% { transform: translate(0px,-50%) scale(0); }
  50% { transform: translate(0px,-50%) scale(1); }
  75% { transform: translate(36px,-50%) scale(1); }
  100% { transform: translate(68px,-50%) scale(1); }
`;
const loaderR = keyframes `
  0% { transform: translate(68px,-50%) scale(1): }
  100% { transform: translate(68px,-50%) scale(0); }
`;
export const LoaderContainer = styled.div `
  width: 84px;
  background: none;
  display: inline-block;
  padding: 0px 0px 14px;
`;
export const LoaderComponent = styled.div `
  width: 100%;
  height: 100%;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
  position: relative;
`;
export const Dot = styled.div `
  width: 16px;
  height: 16px;
  background: ${({ theme }) => theme.colors.primary.normal};
  border-radius: 50%;
  transform: translate(36px, -50%) scale(1);
  top: 8px;
  animation: ${loader} 3.3333333333333335s infinite cubic-bezier(0, 0.5, 0.5, 1);
  box-sizing: content-box;
  position: absolute;

  &:nth-child(1) {
    background: ${({ theme }) => theme.colors.tertiary.normal};
    transform: translate(68px, -50%) scale(1);
    animation: ${loaderR} 0.8333333333333334s infinite cubic-bezier(0, 0.5, 0.5, 1);
  }

  &:nth-child(2) {
    background: ${({ theme }) => theme.colors.primary.normal};
    animation-delay: -0.8333333333333334s;
  }

  &:nth-child(3) {
    background: ${({ theme }) => theme.colors.tertiary.normal};
    animation-delay: -1.6666666666666667s;
  }

  &:nth-child(4) {
    background: ${({ theme }) => theme.colors.secondary.normal};
    animation-delay: -2.5s;
  }

  &:nth-child(5) {
    background: ${({ theme }) => theme.colors.tertiary.normal};
    animation-delay: -3.3333333333333335s;
  }
`;
